import { ISortOrderEnum } from 'shared/models/List'
import { getActiveClient } from 'shared/store/clients/selectors'
import { emptySplitApi, RootState } from 'shared/store/store'
import {
  CasesQueryStatusEnum,
  CasesSortColumnEnum,
  IBoardCaseFilter,
  IBoardCasesList,
} from '../../../models/BoardCase'
import { GET_PROPOSED_CASES } from 'shared/constants/storeTags'

const headers = {
  'x-api-version': '1.0',
}

const proposedService = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    // Fetch proposed
    fetchProposed: builder.query<IBoardCasesList, number>({
      keepUnusedDataFor: 0,
      providesTags: [GET_PROPOSED_CASES],
      async queryFn(take, { getState }, _, baseQuery) {
        const state = getState() as RootState
        const client = getActiveClient(state)

        if (!client) {
          throw new Error('No client connected')
        }

        const body: IBoardCaseFilter = {
          clientId: client.id,
          queryStatus: CasesQueryStatusEnum.ActiveCasesThatCanBeAddedToMeeting,
          sortOrder: ISortOrderEnum.desc,
          searchText: '',
          sortColumn: CasesSortColumnEnum.Created,
          skip: 0,
          take,
          searchStatus: '',
        }

        const res = await baseQuery({
          url: 'boardmeetings/cases/query',
          method: 'POST',
          data: body,
          headers,
        })

        if (res.error) return { error: res.error }

        return { data: res.data as IBoardCasesList }
      },
    }),
  }),
})

export const { useFetchProposedQuery } = proposedService
export default proposedService
